<template>
  <div>
    <div class="content-wrapper">
      <label class="mr-2 select-label">{{ title }}</label>
      <v-select
        :style="filtersComboboxStyle"
        class="combo-box filter-select"
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :items="values"
        variant="outlined"
        density="compact"
        sm="6"
        chips
        attach
        multiple
        hide-details
      ></v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "FiltersCombobox",
  emits: ["update:modelValue"],

  props: {
    values: Array,
    modelValue: Object,
    title: String,
    width: Number
  },

  computed: {
    filtersComboboxStyle() {
      return {
        width: `${this.width}px`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/combobox";

.content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.select-label {
  font-size: 0.8em;
}
.filter-select {
  display: inline-block;
}
</style>
